const $ = window.jQuery

import LazyLoad from 'vanilla-lazyload'

$.expr[':'].external = function(obj){
    return !obj.href.match(/^mailto\:/)
           && (obj.hostname != location.hostname)
           && !obj.href.match(/^javascript\:/)
           && !obj.href.match(/^$/)
};

const mainContentForTouch = false
const $html = $('html')
const $body = $('body')
const $window = $(window)

const stickyOffset = function(){
	// return $('[data-main-nav]').height()
  return $('#main-header .navbar-nav').height() + 40;
}

let lazyLoadInstance = null
const lazyLoadInstanceInit = function() {
  // https://github.com/verlok/lazyload#-api
  lazyLoadInstance = new LazyLoad({
      callback_loaded: (el)=>{
        // masonry.update()
        appUtils.$window.trigger('image_loaded')
      },
      elements_selector: '.lazy',
      load_delay: 300 //adjust according to use case
  });
}


const appUtils = {
  setNavigationPanel: function(value) {
    if (appUtils.$html.attr('data-navigation-panel') !== value) {
      appUtils.$html.attr('data-navigation-panel', value)
    } else {
      appUtils.$html.attr('data-navigation-panel', '')
    }
  },
  lazyLoadInstanceInit: lazyLoadInstanceInit,
  mainContentForTouch: mainContentForTouch,
  $html: $html,
  $body: $body,
  $window: $window,
  isTouch: function () {
    if(typeof(Modernizr) === 'object'){
      return (Modernizr.touchevents)
    }else{
      // return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
      return (
        !!(typeof window !== 'undefined' &&
          ('ontouchstart' in window ||
            (window.DocumentTouch &&
              typeof document !== 'undefined' &&
              document instanceof window.DocumentTouch))) ||
        !!(typeof navigator !== 'undefined' &&
          (navigator.maxTouchPoints || navigator.msMaxTouchPoints))
      )
    }
  },
  isIos: function () {
    // return !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
  },
  isPortrait: function () {
    // when keaborad is open, poprtrait smartphone became landscape! prevent this!
    return (window.innerWidth < window.innerHeight) || (window.innerWidth < 992)
  },

  // Bootstrap 4 breakpoints
  isXs: function () {
    return window.innerWidth < 576
  },
  isSm: function () {
    return window.innerWidth >= 576
  },
  isMd: function () {
    return window.innerWidth >= 768
  },
  isLg: function () {
    return window.innerWidth >= 992
  },
  isXl: function () {
    return window.innerWidth >= 1200
  },

  lazyUpdate: function(){
    if (lazyLoadInstance) {
        lazyLoadInstance.update()
    }
  },
  scrollTo: function(selector, offset, duration ){
    if (typeof(duration) === 'undefined') {
      duration = 400
    }

    $('.is-scroll-target').removeClass('is-scroll-target')

    let scrollDestination = 0
    let dataScrollOffset = null
    if (typeof(selector) === 'string') {
      const $destination = $(selector)
      if ($destination.length) {
        $destination.addClass('is-scroll-target')
        scrollDestination = $destination.offset().top
        dataScrollOffset = ($destination.attr('data-scroll-offset')) ? parseInt($destination.attr('data-scroll-offset'), 10) : null
      }
    } else if (typeof(selector) === 'number') {
      scrollDestination = selector
    } else if (typeof(selector) === 'object') {
      if (selector.length) {
        selector.addClass('is-scroll-target')
        scrollDestination = selector.offset().top
      }
    }

    if(typeof(offset) !== 'number'){
      offset = (dataScrollOffset !== null) ? dataScrollOffset : stickyOffset()
    }

    if(scrollDestination && mainContentForTouch && appUtils.isTouch()) {
      $('#barba-wrapper').animate({
        scrollTop: scrollDestination - offset
      }, duration);
    } else {
      $('html, body').animate({
        scrollTop: scrollDestination - offset
      }, duration);
    }
  },

  // https://stackoverflow.com/questions/6238351/fastest-way-to-detect-external-urls
  checkDomain: function(url) {
    if ( url.indexOf('//') === 0 ) { url = location.protocol + url; }
    return url.toLowerCase().replace(/([a-z])?:\/\//,'$1').split('/')[0];
  },
  isExternal: function(url) {
    return ( ( url.indexOf(':') > -1 || url.indexOf('//') > -1 ) && appUtils.checkDomain(location.href) !== appUtils.checkDomain(url) );
  },
  goTo: function(url) {
    if (appUtils.isExternal(url)) {
      if ( (url.indexOf('|modal')!== -1) && typeof(appUtils.openIframeModal) === 'function') {
        appUtils.openIframeModal(url.replace('|modal', ''))
      } else {
        window.open(url)
      }
    } else {
      // goBarba(url)
      window.location.href = url
    }
  },
  // Iframe modal
  openIframeModal: function(iframeSrc) {
    const modalMarkup = '<div class="modal fade" id="modalIframe" tabindex="-1" role="dialog" aria-labelledby="modalIframeTitle" aria-hidden="true">' +
      '<button type="button" class="modal-close btn btn--small" data-dismiss="modal" aria-label="Close">' +
        '<span aria-hidden="true" class="icon-close"></span>' +
      '</button>' +
      '<div class="modal-dialog modal-dialog-centered modal-dialog-iframe" role="document">' +
        '<div class="modal-content">' +
          '<div class="embed-responsive embed-responsive-16by9">' +
              '<iframe class="embed-responsive-item" src="' + iframeSrc + '" allow="autoplay; encrypted-media" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>'
    $('body').append(modalMarkup)

    setTimeout(()=>{
      $('#modalIframe').on('hidden.bs.modal', function (e) {
        $('#modalIframe').remove()
      }).modal('show')
    }, 0)
  },

  /*
  * App utility to append script to document body
  */
  addedScripts: [],
  addScript: function( src, callback ) {
    if (appUtils.addedScripts.indexOf(src) === -1) {
      appUtils.addedScripts.push(src)
      var s = document.createElement( 'script' )
      s.setAttribute( 'src', src )
      s.onload=callback
      //document.querySelector('#barba-wrapper .barba-container').appendChild( s )
      document.body.appendChild( s )
    } else {
      callback()
    }
  },

  progressBarrSelector: '#progress-bar',

  triggerEvent: function(eventName, args) {
    appUtils.$window.trigger(eventName, args)
  }
}

export default appUtils
